module.exports = __webpack_public_path__ + "img/1f634.6260d8b.svg";